import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';

import {gdk_CONFIG_URL} from './services/gdk-http-client.service';

@NgModule()
export class GdkHttpClientConfigModule {
  constructor(@Optional() @SkipSelf() parentModule: GdkHttpClientConfigModule) {
    if (parentModule) {
      throw new Error('GdkHttpClientConfigModule is already loaded. Import it in the AppModule only!');
    }
  }

  static forRoot(config): ModuleWithProviders {
    return {
      ngModule: GdkHttpClientConfigModule,
      providers: [
        {
          provide: gdk_CONFIG_URL,
          useValue: config
        }
      ]
    };
  }
}
